// removed by extract-text-webpack-plugin
module.exports = {"BreadBottom":"BurgerIngredient__BreadBottom__pgUas","BreadTop":"BurgerIngredient__BreadTop__1qwk-","Seeds1":"BurgerIngredient__Seeds1__1NoR3","Seeds2":"BurgerIngredient__Seeds2__rJjjN","Meat":"BurgerIngredient__Meat__27By3","Cheese":"BurgerIngredient__Cheese__3Xxg-","Salad":"BurgerIngredient__Salad__PEJF9","Bacon":"BurgerIngredient__Bacon__1FuPv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BurgerIngredients/BurgerIngredient.css
// module id = 132
// module chunks = 3